const STATUS_COLOR = {
  Pending: "#0EA5E9",
  Confirmed: "#0EA5E9",
  Processing: "#6366F1",
  Packed: "#8B5CF6",
  Ready: "#14B8A6",
  "Out for delivery": "#F59E0B",
  Delivered: "#16A34A",
  Cancelled: "#DC2626",
  Returned: "#E11D48",
  Refunded: "#DB2777",
};

export const statusColor = (s) => STATUS_COLOR[s] || "#64748B";

export default function OrderStatusPill({ status, testid }) {
  const c = statusColor(status);
  return (
    <span
      data-testid={testid || "order-status-pill"}
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-extrabold whitespace-nowrap"
      style={{ color: c, backgroundColor: c + "22" }}
    >
      {status}
    </span>
  );
}
